var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { MainHeading, GroupingDropdown, HeadingTitle, ToggleOddsBtn } from "../../components";
import { InstantCollapsible } from "sb-resp-ui";
import { RenderMarketNames } from "../RenderComponents";
import { CardType } from "../../../../data";
import { marketColumnsDisplay } from "../../../../constants";
import { ContainerQuery } from "react-container-query";
var MainContent = /** @class */ (function (_super) {
    __extends(MainContent, _super);
    function MainContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainContent.prototype.renderGroupingDropdown = function () {
        return this.props.filterProps && this.props.filterProps.shouldShow &&
            React.createElement(GroupingDropdown, __assign({}, this.props.filterProps));
    };
    MainContent.prototype.renderToggleButton = function () {
        return this.props.toggleOddsBtn && this.props.toggleOddsBtn.shouldShow &&
            React.createElement(ToggleOddsBtn, __assign({}, this.props.toggleOddsBtn));
    };
    MainContent.prototype.renderMarketNames = function (params) {
        return this.props.marketNames.length > 0 &&
            React.createElement(RenderMarketNames, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params });
    };
    MainContent.prototype.renderHeading = function (renderChildren, params) {
        return React.createElement(React.Fragment, null,
            React.createElement(MainHeading, { key: "sport-" + this.props.id, cardType: this.props.cardType },
                React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
                this.renderMarketNames(params),
                this.renderToggleButton(),
                this.renderGroupingDropdown()),
            renderChildren && this.props.children);
    };
    MainContent.prototype.renderHeadingWrapper = function (renderChildren) {
        var _this = this;
        return this.props.cardType === CardType.Multiview
            ? React.createElement(ContainerQuery, { query: marketColumnsDisplay }, function (params) { return _this.renderHeading(renderChildren, params); })
            : this.renderHeading(renderChildren);
    };
    MainContent.prototype.render = function () {
        return React.createElement("div", { className: "rj-ev-list__content", key: "sport-" + this.props.id + "-content", "data-uat": "div-ev-list-content" }, this.props.shouldCollapse
            ? (React.createElement(InstantCollapsible, { key: "collapse-subheading-" + this.props.id, initiallyExpanded: this.props.shouldExpand, trigger: this.renderHeadingWrapper(false), content: React.createElement(React.Fragment, null, this.props.children) }))
            : this.renderHeadingWrapper(true));
    };
    return MainContent;
}(React.PureComponent));
export { MainContent };
//# sourceMappingURL=MainContent.js.map